import { useEffect } from 'react'
import { useRouteError } from 'react-router-dom'
import feLogger from '~/lib/feLogger'

export default function RouteErrorBoundary() {
	const error = useRouteError()

	useEffect(() => {
		if (error) {
			console.error('[RouteErrorBoundary] Error caught:', error)
			feLogger.reportError(error)
		}
	}, [error])

	return (
		<div style={{ padding: '2rem', fontFamily: 'system-ui' }}>
			<h2>Unexpected Application Error!</h2>
			<h3>{error?.message || 'An error occurred'}</h3>
			<details style={{ whiteSpace: 'pre-wrap', marginTop: '1rem' }}>
				<summary>Error Details</summary>
				{error?.error?.stack || String(error)}
			</details>
			<p style={{ marginTop: '1rem' }}>
				<button onClick={() => window.location.reload()}>Reload Page</button>
			</p>
		</div>
	)
}
